export class ListCredentialsProfilesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListCredentialsProfilesFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortCredentialsProfileBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListCredentialsProfilesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
